import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "courseCard",
    "selectedCoursesCount",
    "viewSelectedCoursesBtn",
    "selectedCoursesList",
    "totalFee",
    "continueButton",
    "proceedButton",
    "selectedCourseIdsInput"
  ]

  connect() {
    this.selectedCourses = new Map()
    this.updateSelectedCoursesUI()
  }

  toggleCourseSelection(event) {
    // Don't toggle if clicking on the action button
    if (event.target.closest('.course-action')) return

    const card = event.currentTarget
    const courseId = card.dataset.courseId
    const courseName = card.dataset.courseName
    const courseFee = parseInt(card.dataset.courseFee)

    if (this.selectedCourses.has(courseId)) {
      this.selectedCourses.delete(courseId)
      card.classList.remove('selected')
    } else {
      this.selectedCourses.set(courseId, { id: courseId, name: courseName, fee: courseFee })
      card.classList.add('selected')
    }

    this.updateSelectedCoursesUI()
  }

  clearSelection() {
    this.selectedCourses.clear()
    this.courseCardTargets.forEach(card => {
      card.classList.remove('selected')
    })
    this.updateSelectedCoursesUI()
  }

  removeCourse(event) {
    const courseId = event.currentTarget.dataset.courseId
    this.selectedCourses.delete(courseId)

    // Find and deselect the corresponding card
    const card = this.courseCardTargets.find(card => card.dataset.courseId === courseId)
    if (card) {
      card.classList.remove('selected')
    }

    this.updateSelectedCoursesUI()
  }

  showSelectedCoursesModal() {
    const modal = new bootstrap.Modal(document.getElementById('selectedCoursesModal'))
    modal.show()
  }

  updateSelectedCoursesUI() {
    const count = this.selectedCourses.size
    this.selectedCoursesCountTarget.textContent = `${count} lớp học đã chọn`

    // Enable/disable buttons based on selection
    this.viewSelectedCoursesBtnTarget.disabled = count === 0
    this.continueButtonTarget.disabled = count === 0
    this.proceedButtonTarget.disabled = count === 0

    // Update selected courses list in modal
    if (count === 0) {
      this.selectedCoursesListTarget.innerHTML = '<p class="text-center text-muted">Chưa có lớp học nào được chọn</p>'
      this.totalFeeTarget.textContent = '0 VNĐ'
    } else {
      let html = '<div class="list-group">'
      let totalFee = 0

      this.selectedCourses.forEach(course => {
        totalFee += course.fee
        html += `
          <div class="list-group-item d-flex justify-content-between align-items-center">
            <div>${course.name}</div>
            <div class="d-flex align-items-center">
              <span class="me-3">${new Intl.NumberFormat('vi-VN').format(course.fee)} VNĐ</span>
              <button type="button" class="btn btn-outline-danger btn-sm"
                      data-course-id="${course.id}"
                      data-action="course-selection#removeCourse">
                <i class="bx bx-x"></i>
              </button>
            </div>
          </div>
        `
      })

      html += '</div>'
      this.selectedCoursesListTarget.innerHTML = html
      this.totalFeeTarget.textContent = `${new Intl.NumberFormat('vi-VN').format(totalFee)} VNĐ`
    }

    // Update hidden input with selected course IDs
    this.selectedCourseIdsInputTarget.value = Array.from(this.selectedCourses.keys()).join(',')

    // Update form action
    this.updateProceedFormAction()
  }

  updateProceedFormAction() {
    if (this.selectedCourses.size > 0) {
      const firstCourseId = Array.from(this.selectedCourses.keys())[0]
      const proceedForm = this.selectedCourseIdsInputTarget.closest('form')
      proceedForm.action = `/courses/${firstCourseId}/registrations/member_info`
    }
  }
}
